import React, { useState, useEffect } from 'react';
import S from './FormDuration.module.scss';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import Bouton from '../../UI/Bouton/Bouton';

import { FaCalendarDay, FaRegClock } from 'react-icons/fa';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import * as glossaire_pattern from '../../../ressources/glossaires/glossaire_pattern';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import FormulaireSelectionDateHeureUnix from '../../Graphe/ProfilGraphe/FormulaireGraphe/FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';
export const TIME_UNITS = {
  heure: 3600,
  jours: 86400,
  semaines: 604800,
};

interface FormDateProps {
  setTime: (startInterval?: number, endInterval?: number) => void;
}

const renderOptions = () => {
  return Object.keys(TIME_UNITS).map((unit) => {
    return (
      <option key={unit} value={unit}>
        {checkMot(unit)}
      </option>
    );
  });
};

const FormDate = (props: FormDateProps) => {
  const [timeValue, setTimeValue] = useState<number>(1);
  const [timeUnit, setTimeUnit] = useState<string>('jours');
  const [dateSelectionType, setDateSelectionType] = useState<string>('period');
  const [calendarStartDay] = useState<Date>(new Date());
  const [calendarEndDay] = useState<Date>(new Date());

  useEffect(() => {
    calculateUnixTime(timeUnit, timeValue);
  }, [timeUnit, timeValue]);

  useEffect(() => {
    if (dateSelectionType === 'period') {
      const startInterval = Math.floor(
        (new Date().getTime() - 24 * 60 * 60 * 1000) / 1000
      );
      const endInterval = Math.floor(new Date().getTime() / 1000);
      props.setTime(startInterval, endInterval);
    } else {
      props.setTime(
        Math.floor(calendarStartDay.getTime() / 1000),
        Math.floor(calendarEndDay.getTime() / 1000)
      );
    }
  }, [dateSelectionType, calendarStartDay, calendarEndDay]);

  const calculateUnixTime = (timeUnit: string, timeValue: number) => {
    if (isNaN(timeValue)) {
      return;
    }
    const now = new Date();
    if (timeUnit !== 'heure') {
      now.setHours(0, 0, 0, 0);
    }
    const endInterval =
      timeUnit === 'heure'
        ? Math.floor(now.getTime() / 1000)
        : Math.floor((now.getTime() + 24 * 60 * 60 * 1000) / 1000);
    const unixTime =
      timeValue * TIME_UNITS[timeUnit as keyof typeof TIME_UNITS];
    const startInterval = Math.floor(endInterval - unixTime);
    props.setTime(startInterval, endInterval);
  };

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value);
    if (!isNaN(value)) {
      setTimeValue(Math.abs(value));
    }
  };

  const handleTimeUnitChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setTimeUnit(event.currentTarget.value);
  };

  return (
    <div className={S.conteneur_input}>
      {dateSelectionType === 'period' ? (
        <>
          <Bouton
            key={'switch-between-date-selection-type'}
            overText={'Changer le type de sélection de date à du au'}
            type={type_btn.outil}
            rond={true}
            cliquer={() => setDateSelectionType('ecart')}
          >
            <FaCalendarDay size={15} />
          </Bouton>
          <input
            className={[s.form_control, s.col_5].join(' ')}
            pattern={glossaire_pattern.integer}
            placeholder={checkMot(timeUnit)}
            type="number"
            value={timeValue}
            onChange={handleValueChange}
            min={1}
          />
          <select
            className={[s.custom_select, s.col_6, S.text_geral].join(' ')}
            defaultChecked={true}
            value={timeUnit}
            onChange={handleTimeUnitChange}
          >
            {renderOptions()}
          </select>
        </>
      ) : (
        <>
          <Bouton
            key={'switch-between-date-selection-type'}
            overText={
              "Changer le type de sélection de date à depuis aujourd'hui"
            }
            type={type_btn.outil}
            rond={true}
            cliquer={() => setDateSelectionType('period')}
          >
            <FaRegClock size={15} />
          </Bouton>
          <div className={s.col_5}>
            <FormulaireSelectionDateHeureUnix
              value={calendarStartDay.getTime() / 1000}
              gereUnixDate={(startDate: number) => props.setTime(startDate)}
            />
          </div>
          <div className={s.col_5}>
            <FormulaireSelectionDateHeureUnix
              value={calendarEndDay.getTime() / 1000}
              gereUnixDate={(endDate: number) =>
                props.setTime(undefined, endDate)
              }
            />
          </div>
        </>
      )}
    </div>
  );
};

export default FormDate;
